import { useOnScreen } from '@/core/hooks/useOnScreen'
import Box from '@mui/material/Box'
import { useRef } from 'react'
import { RcSuspense, RcSuspenseProps } from './RcSuspense'

export const RenderOnScreen = ({ children, ...rest }: RcSuspenseProps) => {
  const ref = useRef<HTMLElement>()
  const scrolled = useOnScreen({ ref, rootMargin: '150px', setOnce: true })

  return (
    <Box ref={ref} height={rest.height}>
      <RcSuspense {...rest}>{scrolled ? children : null}</RcSuspense>
    </Box>
  )
}
